export function getSponsoredWidgetQueryDate() {
    const regex = /[?&]sw_date=([^&]+)/;
    const match = regex.exec(window.location.search);
    const date = match ? new Date(decodeURIComponent(match[1])) : null;
    return date && (date.toString() !== 'Invalid Date' ? date : null);
}
